// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1YIRE","info":"UpdateTermsInfo_info__2Ur5d"};